// extracted by mini-css-extract-plugin
export default {"container":"FriendsButton_container__ATS1S","flex":"FriendsButton_flex__TNhgS","secondFlexItem":"FriendsButton_secondFlexItem__ff9W+"};